<template>
    <div>
      <h2>{{ formTitle | upper }}</h2>
      <el-form ref="form" :model="form" label-width="120px" :label-position="'top'" >

        <el-row :gutter="20">
          <el-col :lg="12" :xl="12">
            <el-form-item label="Nom">
              <el-input placeholder="Nom de l'opérateur" v-model="form.firstname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xl="12">
            <el-form-item label="Prénom">
              <el-input placeholder="Prénom de l'opérateur" v-model="form.lastname"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

         <el-row :gutter="20">
          <el-col :lg="12" :xl="12">
            <el-form-item :label="$t('associated_beacon_id')">
              <el-input :placeholder="$t('associated_beacon_id')" v-model="form.beaconId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xl="12">
            <el-form-item label="Groupe">
              <el-select v-model="form.group" placeholder="Select">
                <el-option
                  v-for="item in groupOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        
        <el-row class="form-row-margin">
          <el-col :lg="12">
            <el-tag
              :key="tag"
              v-for="tag in form.tags"
              closable
              :disable-transitions="false"
              @close="handleCloseTag(tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="tagInputVisible"
              v-model="tagInputValue"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleInputConfirmTag"
              @blur="handleInputConfirmTag"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputTag">+ {{ $t('add_tag') }}</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item>
            <el-button type="success" @click="createOperator">{{ $t(formState) | upper}}</el-button>
            <el-button @click="initFormAndClose">ANNULER</el-button>
          </el-form-item>
        </el-row>

      </el-form>
    </div>
</template>

<script>
//-- WIP (no axios or store)

import { operatorsTable, opFabTable } from '../../data/dynamoDBSimulation.js'; //-- Simulate Data from DynamoDB
import CleanObject from '../../mixins/CleanObject';
import DateTimeManipulation from '../../mixins/DateTimeManipulation';

export default {
  props: {
    formStateModal: {
      type: String,
    },
    ofSelected: {
      type: Object
    },
    formTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      operatorsList: [],
      piReceptorList: [],
      checkboxMachines: [],
      formState: 'create',
      tagInputVisible: false,
      tagInputValue: '',
      groupOptions: [
        {value: 'operator', label: 'Operateur'},
        {value: 'maintenance', label: 'Maintenance'},
        {value: 'manager', label: 'Responsable'},
      ],
      form: {
        id: '',
        firstname: '',
        lastname: '',
        beaconId: '',
        group: '',
        tags: []
      }
    }
  },
  created () {
    this.operatorsList = this.dataToTransfert(operatorsTable, ['operator_id', 'firstName', 'lastName']);
    let productionZone = this.$store.getters.productionZones;
    this.piReceptorList = this.dataToTransfert(productionZone, ['id', 'name']);
    if(this.formStateModal !== undefined) {
      this.formState = this.formStateModal;
    } else {
      this.setFormState(this.$route.name);
    }
    if(this.ofSelected !== undefined) {
      this.setForm(this.ofSelected);
    } else if(this.formState === 'edit' || this.formState === 'duplicate') {
      //-- Fetch OF with id form.of_if
      let selectedOf = opFabTable.find( elmt => elmt.id === this.form.id );
      this.setForm(selectedOf);
    }
  },
  methods: {
    dataToTransfert: function(collection, keyList) {
      let data = []
      if(collection !== undefined) {
        collection.forEach( dt => {
          let objToData = {};
          objToData.key = dt[keyList[0]];
          objToData.label = `${dt[keyList[1]]} ${dt[keyList[2]] !== undefined ? dt[keyList[2]]: ''}`;
          objToData.disabled = false;
          data.push(objToData);
        });
      }
      return data;
    },
    getMachineIdInsteadOfName: function(machineSelectedList, piReceptorList) {
      let machinesId = [];
      if(machineSelectedList !== undefined) {
        machineSelectedList.forEach( name => {
          const founded = piReceptorList.find( obj => obj.name === name);
          machinesId.push(founded.id);
        })
      }
      return machinesId;
    },
    getMachineNameInsteadOfId: function(machineSelectedList, piReceptorList) {
      let machinesName = [];
      if(machineSelectedList !== undefined) {
        machineSelectedList.forEach( id => {
          const founded = piReceptorList.find( obj => obj.id === id);
          machinesName.push(founded.name);
        })
      }
      return machinesName;
    },
    setFormState: function(routeName) {
      if(routeName.includes('create')) {
        this.formState = 'create';
      } else if(routeName.includes('duplicate')) {
        this.formState = 'duplicate';
        this.form.id = this.$route.params.id;
      } else if(routeName.includes('edit')) {
        this.formState = 'edit';
        this.form.id = this.$route.params.id;
      }
    },
    handleCloseTag(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    showInputTag() {
      this.tagInputVisible = true;
      this.$nextTick( () => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirmTag() {
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.form.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    setForm: function(data) {
      this.form.firstname = data.firstname;
      this.form.lastname = data.lastname;
      this.form.beaconId = data.beaconId;
      this.form.group = data.group;
      this.form.tags = data.tags !== undefined ?  data.tags : [];
    },
    initForm: function() {
      this.form = {
        id: '',
        firstname: '',
        lastname: '',
        beaconId: '',
        group: '',
        tags: []
      },
      this.checkboxMachines = [];
    },
    initFormAndClose: function() {
      //this.initForm();
      this.$emit('closeForm', false);
    },
    createOperator: function() {
      let cleanedForm = this.cleanObject(this.form);
      if(this.formState === 'create' || this.formState === 'duplicate') {
        this.$store.dispatch('postOperators', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          res.status === 200 ? this.initForm() : '';
        })
      }
      if(this.formState === 'edit') {
        cleanedForm.id = this.ofSelected.id
        this.$store.dispatch('editOperator', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          res.status === 200 ? this.initForm() : '';
        })
      }
    }
  },
  mixins: [CleanObject, DateTimeManipulation]
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .form-row-margin {
    margin-bottom: 24px;
  }
</style>